import { Resizable } from 're-resizable';
import { useContext, useEffect } from 'react';
import styled from 'styled-components';
import { FileContext } from '../../../context/FileContext';
import ImageIcon from '../../../assets/icons/image.svg';

const OuterContainer = styled.div`
  border: 2px solid transparent !important;
  border-radius: 1px !important;

  &.active {
    border: 1px dashed rgba(0, 115, 234, 0.4) !important;
    padding: 1px;
  }

  &.hover-active:hover {
    border: 2px solid rgba(0, 115, 234, 0.4) !important;
  }
`;
const ImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ hasImageUrl }) => (hasImageUrl ? 'transparent' : '#e2f2ff')};
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .no-image-container {
    height: 35%;
    width: 35%;
  }
`;

const PrefilledFieldsImageEditOverlayChip = ({ item, setIsResizing }) => {
  const {
    addedFormFields,
    updateFormFields,
    currentSelectedItem,
    draggableFieldsData,
    columnValuesMap,
  } = useContext(FileContext);

  const defaultHeight = 150;
  const defaultWidth = 200;

  useEffect(() => {
    if (!item?.width) item.width = defaultWidth;
    if (!item?.height) item.height = defaultHeight;
  }, []);

  const handleResizeStart = (_e, _dir) => {
    setIsResizing(true);
  };

  const handleResizeEnd = (item) => (_e, _dir, _ref, d) => {
    setIsResizing(false);

    item.width += d.width;
    item.height += d.height;

    addedFormFields[currentSelectedItem.current] = item;
    draggableFieldsData[item.itemId] = {
      height: item.height,
      width: item.width,
    };
    updateFormFields([...addedFormFields]);
  };

  const isValidFileExtension = (url) => {
    const urlArray = url.split(', ');
    const supportedExtensions = ['jpg', 'jpeg', 'png', 'JPG', 'PNG', 'JPEG'];

    if (urlArray.length) {
      for (const url of urlArray) {
        const splittedUrl = url.split('/');
        const fileName = splittedUrl.at(-1);
        const fileExtension = fileName.split('.').at(-1);
        const isValid = supportedExtensions.includes(fileExtension);

        if (isValid) {
          return url;
        }
      }
    }

    return '';
  };

  const imageUrl = isValidFileExtension(
    columnValuesMap?.get(item?.itemId)?.text || '',
  );

  return (
    <OuterContainer className={item.isActive ? 'active' : 'hover-active'}>
      <Resizable
        id="prefilled-fields-resizable-image-container"
        size={{
          height: item?.height || defaultHeight,
          width: item?.width || defaultWidth,
        }}
        lockAspectRatio={false}
        enable={{
          top: false,
          right: item?.isActive,
          bottom: item?.isActive,
          left: false,
          topRight: false,
          bottomRight: item?.isActive,
          bottomLeft: false,
          topLeft: false,
        }}
        onResizeStart={handleResizeStart}
        onResizeStop={handleResizeEnd(item)}
      >
        <ImageContainer hasImageUrl={!!imageUrl}>
          {imageUrl ? (
            <img src={imageUrl} alt="No attachment" />
          ) : (
            <div className="no-image-container">
              <img src={ImageIcon} alt="" />
            </div>
          )}
        </ImageContainer>
      </Resizable>
    </OuterContainer>
  );
};

export default PrefilledFieldsImageEditOverlayChip;
